import { withProps } from 'recompose';
import { canUserModifyBarbers } from '../../../../../common/helpers/users';

export default withProps(
  props => ({
    canModify: canUserModifyBarbers(props.permissions),
  })
);
